export default "__VITE_ASSET__b52dca52__"